import * as fromRoot from '@core/store/reducers';
import { createSelector } from '@ngrx/store';
import { UserRole } from '@wtax/data-angular';

export const isCurrentUserCustodian = createSelector(fromRoot.selectUserRole, (role) => role === UserRole.CUSTODIAN);
export const isCurrentUserFundOrWealthManager = createSelector(fromRoot.selectUserRole, (role) => {
  return role === UserRole.WEALTH_MANAGER || role === UserRole.FUND_MANAGER;
});
